import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { clearStoredAuthSession } from '@/lib/supabase'

// Chặn lỗi "Invalid Refresh Token" bị rò rỉ từ bộ hẹn giờ tự động gia hạn
// của Supabase khi phiên đăng nhập đã hết hạn / bị thu hồi.
// Khi gặp lỗi này, ta dọn luôn token hỏng trong trình duyệt để lần tải sau
// không còn cố gia hạn nó nữa, và ngăn lỗi bắn ra màn hình.
const isBrokenSessionError = (message: string): boolean =>
  message.includes('Invalid Refresh Token') ||
  message.includes('Refresh Token Not Found') ||
  message.includes('refresh_token_not_found')

const handleBrokenSession = (message: string): void => {
  if (!isBrokenSessionError(message)) return
  clearStoredAuthSession()
}

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason as { message?: string } | undefined
  const message =
    typeof reason?.message === 'string'
      ? reason.message
      : String(reason ?? '')

  if (isBrokenSessionError(message)) {
    handleBrokenSession(message)
    event.preventDefault()
  }
})

window.addEventListener('error', (event) => {
  handleBrokenSession(String(event?.message ?? ''))
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)